var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveredBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_987_2461)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_987_2461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20C23.7098 20.0009 22.9333 19.7935 22.2488 19.3986C21.5643 19.0038 20.996 18.4355 20.6012 17.751C20.2064 17.0664 19.999 16.2899 20 15.4997C20.001 14.7095 20.2103 13.9335 20.6068 13.25H14.1815L14.15 12.986C14.0854 12.4389 13.8223 11.9346 13.4106 11.5686C12.999 11.2025 12.4674 11.0002 11.9165 11H11.75C11.5511 11 11.3603 11.079 11.2197 11.2197C11.079 11.3603 11 11.5511 11 11.75C11 11.9489 11.079 12.1397 11.2197 12.2803C11.3603 12.421 11.5511 12.5 11.75 12.5H11.9165C12.1002 12.5 12.2775 12.5675 12.4148 12.6895C12.5521 12.8116 12.6398 12.9798 12.6612 13.1623L13.6933 21.9373C13.8004 22.8498 14.2389 23.6913 14.9254 24.302C15.612 24.9127 16.4989 25.25 17.4178 25.25H25.25C25.4489 25.25 25.6397 25.171 25.7803 25.0303C25.921 24.8897 26 24.6989 26 24.5C26 24.3011 25.921 24.1103 25.7803 23.9697C25.6397 23.829 25.4489 23.75 25.25 23.75H17.4178C16.9534 23.7488 16.5008 23.6041 16.122 23.3355C15.7432 23.067 15.4568 22.6878 15.302 22.25H24.2428C25.122 22.2501 25.9733 21.9412 26.6479 21.3773C27.3225 20.8135 27.7775 20.0305 27.9335 19.1652L28.112 18.176C27.6948 18.7416 27.1506 19.2014 26.5232 19.5182C25.8959 19.835 25.2028 20 24.5 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 29.0005C17.0784 29.0005 17.75 28.3289 17.75 27.5005C17.75 26.6721 17.0784 26.0005 16.25 26.0005C15.4216 26.0005 14.75 26.6721 14.75 27.5005C14.75 28.3289 15.4216 29.0005 16.25 29.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 29.0005C24.5784 29.0005 25.25 28.3289 25.25 27.5005C25.25 26.6721 24.5784 26.0005 23.75 26.0005C22.9216 26.0005 22.25 26.6721 22.25 27.5005C22.25 28.3289 22.9216 29.0005 23.75 29.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7996 17.7093C22.9286 17.8486 23.0845 17.9603 23.2578 18.0377C23.4312 18.115 23.6185 18.1564 23.8083 18.1593H23.8331C24.0191 18.1599 24.2034 18.1236 24.3753 18.0524C24.5472 17.9812 24.7032 17.8766 24.8343 17.7446L28.0383 14.5406C28.1796 14.3995 28.2592 14.2081 28.2594 14.0085C28.2596 13.8088 28.1805 13.6173 28.0394 13.4759C27.8984 13.3346 27.707 13.2551 27.5074 13.2549C27.3077 13.2547 27.1161 13.3338 26.9748 13.4748L23.8346 16.6203L22.9091 15.6273C22.7732 15.4818 22.5851 15.3962 22.3862 15.3894C22.1872 15.3826 21.9937 15.4551 21.8482 15.5909C21.7027 15.7268 21.6171 15.9149 21.6103 16.1138C21.6035 16.3128 21.676 16.5063 21.8118 16.6518L22.7996 17.7093Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_987_2461",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22CAAD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_2461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveredBanner);
export default __webpack_public_path__ + "static/media/delivered_banner.8795f3eab52ac8ffe678c9d1b7855345.svg";
export { ForwardRef as ReactComponent };